// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-axios';
import type { RootGetData, MsUserMsUserGetData, MsUserMsUserGetResponse, MsUserMsUserGetError, ReconcileReconcilePostData, ReconcileReconcilePostResponse, ReconcileReconcilePostError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(options?: Options<RootGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/api/',
        ...options
    });
};

/**
 * Ms User
 */
export const msUserMsUserGet = <ThrowOnError extends boolean = false>(options: Options<MsUserMsUserGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MsUserMsUserGetResponse, MsUserMsUserGetError, ThrowOnError>({
        url: '/api/msUser',
        ...options
    });
};

/**
 * Reconcile
 */
export const reconcileReconcilePost = <ThrowOnError extends boolean = false>(options: Options<ReconcileReconcilePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReconcileReconcilePostResponse, ReconcileReconcilePostError, ThrowOnError>({
        url: '/api/reconcile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
